// Shared constants for the admin dashboard components.

// PDF positioning config (same as ContactForm.js)
// x=0 is left edge, y=0 is BOTTOM of page. Letter size: 612 x 792 points.
export const PDF_CONFIG = {
    pageFromEnd: 2,
    signatureX: 85,
    signatureY: 102,
    signatureWidth: 120,
    signatureHeight: 30,
    businessNameX: 54,
    businessNameY: 123,
    nameX: 95,
    nameY: 91,
    licenseX: 180,
    licenseY: 76,
    dateX: 85,
    dateY: 61,
    fontSize: 10,
};

// Authorized users who can approve fee schedules
export const FEE_SCHEDULE_APPROVERS = [
    'zu.dawahra@stampmedical.com',
    'dr.stamp@stampmedical.com'
];

export const SPECIALTY_OPTIONS = [
    { value: "chiropractor", label: "Chiropractor" },
    { value: "physical-therapy", label: "Physical Therapy" },
    { value: "pain-management", label: "Pain Management" },
    { value: "orthopedics", label: "Orthopedics" },
    { value: "neurology", label: "Neurology" },
    { value: "imaging", label: "Imaging" },
    { value: "other", label: "Other" },
];

export const STATE_OPTIONS = [
    { value: "arizona", label: "Arizona" },
    { value: "colorado", label: "Colorado" },
    { value: "nevada", label: "Nevada" },
    { value: "new-mexico", label: "New Mexico" },
    { value: "texas", label: "Texas" },
    { value: "washington", label: "Washington" },
];

// States offered when manually registering a paper contractor
// (matches the public signup form's enabled states)
export const MANUAL_ENTRY_STATE_OPTIONS = STATE_OPTIONS.filter((s) => s.value !== "colorado");

export const ENROLLMENT_OPTIONS = [
    { value: "online", label: "🌐 Online" },
    { value: "paper", label: "📄 Paper" },
];

// Internal onboarding checklist (never shown to contractors).
// Items with an `auto` function are checked automatically when the condition
// is met (e.g. the document exists on the record); everything else is manual.
export const CHECKLIST_SECTIONS = [
    {
        title: "📄 Required Documents",
        items: [
            { key: "agreementReceived", label: "Fully Executed Agreement Received", auto: (s) => !!s.signedPdfUrl, autoHint: "Auto-checked — signed agreement PDF is on file" },
            { key: "w9Received", label: "W-9 Form Received", auto: (s) => !!s.documents?.w9, autoHint: "Auto-checked — W-9 is on file" },
            { key: "directDepositReceived", label: "Direct Deposit Form Received", auto: (s) => !!s.documents?.directDeposit, autoHint: "Auto-checked — Direct Deposit form is on file" },
            { key: "locationListSubmitted", label: "Location List Submitted" },
        ],
    },
    {
        title: "⚙️ Operations Setup",
        items: [
            { key: "locationsImportedToRoutes", label: "Locations Imported to Routes" },
            { key: "locationsAddedToMaps", label: "Locations Added to Maps" },
            { key: "billingTeamNotified", label: "Billing Team Notified" },
            { key: "medicalRecordsTeamNotified", label: "Medical Records Team Notified" },
            { key: "schedulingTeamNotified", label: "Scheduling Team Notified" },
        ],
    },
    {
        title: "🤝 Communication",
        items: [
            { key: "introEmailSent", label: "Introduction Email Sent", auto: (s) => s.emailSent === true, autoHint: "Auto-checked — system email was sent" },
            { key: "pointsOfContactReceived", label: "Primary Points of Contact Received" },
            { key: "meetGreetScheduled", label: "Meet & Greet Scheduled" },
            { key: "meetGreetCompleted", label: "Meet & Greet Completed" },
        ],
    },
];

export const EMPTY_MANUAL_FORM = {
    name: "",
    email: "",
    phone: "",
    specialty: "",
    licenseNumber: "",
    practiceName: "",
    dbaName: "",
    location: "",
    address: "",
    city: "",
    zip: "",
    practicePhone: "",
    npi: "",
    taxId: "",
    message: "",
    sendIntroEmail: true,
};

// Factory (not a constant) so the default quarter is computed at call time
export const makeEmptyQuarterlyForm = () => ({
    quarter: `Q${Math.ceil((new Date().getMonth() + 1) / 3)}`,
    communicationRating: "",
    schedulingLeadTimes: "",
    referralConcerns: "",
    patientComplianceConcerns: "",
    workingWell: "",
    areasToImprove: "",
    supportNeeded: "",
    billingConcerns: "",
    collaborationOpportunities: "",
    overallRating: "",
    followUpItems: "",
    executiveSummary: "",
});
